export default __webpack_public_path__ + "static/media/image-jussi@2x.de5e13da.png";